export default class TicketsModal {
    constructor() {
        this.el = $('.js-tickets-modal');
        this.trigger = $('.js-view-tickets');

        if (!this.el.length || !this.trigger.length) {
            return false;
        }

        this.slickActive = false;
        this.slickEl = this.el.find('.js-slick');
        this.numTickets = this.slickEl.children().length;


        this._onResize = this._onResize.bind(this);
        window.addEventListener('resize', this._onResize);
        this._onResize();

        this._onOpen = this._onOpen.bind(this);
        this.trigger.on('click', this._onOpen);

        this.el.find('.entry .close').each((index, el) => {
            $(el).on('click', () => {
                this.el.css('display', 'none');
                $('body').removeClass('no-scroll');
            });
        });
    }

    _onResize() {
        let ww = $(window).outerWidth();
        if (ww < 992 && !this.slickActive) {
            this._invokeSlickSlider();
        } else if (ww >= 992 && this.numTickets > 3 && !this.slickActive) {
            this._invokeSlickSlider();
        } else if (ww >= 992 && this.numTickets < 4 && this.slickActive) {
            this.slickActive = false;
            this.slickEl.slick('unslick');
        }
    }

    _invokeSlickSlider() {
        this.slickActive = true;
        this.slickEl.slick({
            dots: false,
            infinite: false,
            speed: 450,
            slidesToShow: 1,
            variableWidth: true,
            draggable: true,
            centerMode: true,
            arrows: false,
            cssEase: 'cubic-bezier(0.455, 0.030, 0.515, 0.955)',
        });
    }

    _onOpen() {
        $('body').addClass('no-scroll');
        this.el.css('display', 'block');
        if (this.slickActive) {
            this.el.css('opacity', 0);
            this.slickEl.slick('setPosition');
            setTimeout(() => {
                this.el.css('opacity', 1);
            }, 100);
        }

        return false;
    }
}